import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  icons: { iconfont: 'mdi' },
  theme: {
    dark: localStorage.getItem('evpn-theme') === 'dark',
    themes: {
      dark: {
        primary:   '#00BCD4',
        secondary: '#00838F',
        success:   '#48BB78',
        error:     '#FC8181',
        warning:   '#F6AD55',
        surface:   '#161B22',
        background:'#0D1117'
      },
      light: {
        primary:   '#00BCD4',
        secondary: '#00838F',
        success:   '#48BB78',
        error:     '#E53E3E',
        warning:   '#DD6B20'
      }
    }
  }
});
